module.exports = __webpack_public_path__ + "ecf66f2e4c182ee2dfcca90357a9aef9.otf";